function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.65 15.5c0-.22.08-.41.23-.56a.8.8 0 01.57-.22h12.08c.22 0 .4.07.54.22s.22.34.22.57c0 .22-.07.4-.22.54-.14.14-.32.22-.54.22H5.45c-.22 0-.42-.07-.57-.22a.711.711 0 01-.23-.55zm2.41-2.9c0-.22.08-.4.23-.55a.77.77 0 01.56-.23h12.09c.21 0 .39.08.54.23.15.15.22.33.22.55 0 .22-.07.4-.22.56-.15.15-.33.23-.54.23H7.86c-.22 0-.41-.08-.56-.23s-.24-.34-.24-.56zm1.62 5.74c0-.21.08-.39.24-.54.14-.14.32-.22.54-.22h12.1c.22 0 .41.07.56.22.15.14.22.32.22.54s-.08.41-.23.56-.34.23-.56.23H9.46c-.22 0-.4-.08-.56-.23s-.22-.34-.22-.56zm10.58-2.84c0-.23.07-.42.22-.57.15-.15.34-.22.57-.22h4.52c.23 0 .42.07.57.22.15.15.22.34.22.56 0 .22-.07.4-.22.54s-.34.22-.56.22h-4.52c-.23 0-.42-.07-.57-.22-.16-.13-.23-.31-.23-.53z"
});

function SvgWiWindy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    style: {
      enablebackground: "new 0 0 30 30"
    },
    viewBox: "0 0 30 30"
  }, props), _ref);
}

export default SvgWiWindy;